import { i18nMark } from "@lingui/react";

import { getDayjsObject } from "base/utils";

import { SORTING_HEADER_MENU_LIST } from "../component";

const LINK_COLUMN_WIDTH = 170;

export const COMPONENT_NAMES = {
  AGING: "Aging",
  PERFORMANCE: "Performance",
  USER_PERFORMANCE: "UserPerformance"
};

export function getTime(value) {
  let days = Math.floor(value / (24 * 60));
  if (days) {
    return `${days} Days`;
  }
  let hours = Math.floor(value / 60);
  if (hours) {
    return `${hours} Hrs`;
  }
  if (value > 1) {
    return `${value.toFixed(0)} Mins`;
  }
  return `${value.toFixed(2)} Mins`;
}

export function formatColumns(columns, component) {
  columns.map((column) => {
    column["headerMenuList"] = SORTING_HEADER_MENU_LIST;
    if (component === COMPONENT_NAMES.PERFORMANCE) {
      if (column.Id === "StepName") {
        column["Fixed"] = true;
      }
      column.Width = column.Type !== "Text" ? LINK_COLUMN_WIDTH : undefined;
    } else if (component === COMPONENT_NAMES.AGING) {
      if (column.Id === "StepName") {
        column["Fixed"] = true;
      }
      column.Width = column.Type === "Link" ? LINK_COLUMN_WIDTH : undefined;
    } else if ((component = COMPONENT_NAMES.USER_PERFORMANCE)) {
      if (column.Id === "User") {
        column["Fixed"] = true;
      }
      column.Width = column.Type === "Link" ? LINK_COLUMN_WIDTH : undefined;
    }
    return column;
  });
  return columns;
}

export function getDateRange(dateRange) {
  let range = {
    end_date: getDayjsObject().format("YYYY-MM-DD"),
    start_date: null
  };
  if (dateRange === "LAST_30_DAYS") {
    range.start_date = getDayjsObject()
      .subtract(30, "day")
      .format("YYYY-MM-DD");
  } else if (dateRange === "3_MONTHS") {
    range.start_date = getDayjsObject()
      .subtract(2, "month")
      .format("YYYY-MM-DD");
  } else if (dateRange === "6_MONTHS") {
    range.start_date = getDayjsObject()
      .subtract(6, "month")
      .format("YYYY-MM-DD");
  } else if (dateRange === "1_YEAR") {
    range.start_date = getDayjsObject()
      .subtract(1, "year")
      .format("YYYY-MM-DD");
  }
  return range;
}

export function getTommorow() {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
}

export function getLastYear() {
  const today = new Date();
  const lastYear = new Date(today);
  lastYear.setFullYear(lastYear.getFullYear() - 1);
  return lastYear;
}

const COLUMN_TYPES = {
  MIN_TIME: "MinTime",
  MAX_TIME: "MaxTime",
  AVG_TIME: "AvgTime"
};

export function doesMatch(item, columns, searchText) {
  let query = searchText?.toLowerCase()?.trim();
  let isFound = false;
  columns.forEach((column) => {
    let columnID = column.Id;
    let value = (item && item[columnID]) || "";
    if (item && item[columnID]) {
      if (
        typeof value === "object" &&
        value.Name?.toLowerCase()?.indexOf(query) > -1
      ) {
        isFound = true;
      } else if (value.toString()?.toLowerCase()?.indexOf(query) > -1) {
        isFound = true;
      }
    }
    if (
      typeof value === "number" &&
      (column.Id === COLUMN_TYPES.MIN_TIME ||
        column.Id === COLUMN_TYPES.MAX_TIME ||
        column.Id === COLUMN_TYPES.AVG_TIME)
    ) {
      let disVal = getTime(value);
      if (disVal?.toLowerCase().indexOf(query) > -1) {
        isFound = true;
      }
    }
  });
  return isFound;
}

export const DUEDATE_FILTER = {
  LAST_30_DAYS: i18nMark("Last 30 days"),
  "3_MONTHS": i18nMark("3 months"),
  "6_MONTHS": i18nMark("6 months"),
  "1_YEAR": i18nMark("1 year"),
  CUSTOM_PERIOD: i18nMark("Custom period")
};
